var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageBase',{attrs:{"title":"药品种类","dataList":_vm.datas,"table-columns":_vm.tableColumns,"table-actions":[],"simpleFilter":"","loading":_vm.loading.load},on:{"page-change":_vm.onPageChange}})}
var staticRenderFns = []

export { render, staticRenderFns }